import {
  Model,
  _async,
  _await,
  model,
  modelAction,
  modelFlow,
  prop_mapObject,
} from "mobx-keystone";
import api from "../api";
import {
  APIFormulationApproval,
  APIFormulationApprovalInput,
  APIFormulationApprovalSearchParams,
} from "../api/formulationApprovals";
import FormulationApproval from "./models/FormulationApproval";

@model("collab/FormulationApprovalStore")
class FormulationApprovalStore extends Model({
  listItems: prop_mapObject(() => new Map<identifier, FormulationApproval>()),
}) {

  // Keyed by project: a project has a single sign off, and the pending
  // placeholder returned before the first submit has no id.
  @modelAction
  saveListItem(item: APIFormulationApproval) {
    const listItem = new FormulationApproval(item);
    this.listItems.set(item.projectId, listItem);
    return listItem;
  }

  @modelFlow
  list = _async(function* (
    this: FormulationApprovalStore,
    searchParams: APIFormulationApprovalSearchParams,
    page?: number,
    limit?: number,
  ) {
    const results = yield* _await(api.formulationApprovals.list(page, limit, searchParams));
    this.saveListItem(results);
    return { results };
  });

  @modelFlow
  create = _async(function* (
    this: FormulationApprovalStore,
    projectId: identifier,
    apiData: APIFormulationApprovalInput
  ) {
    const result = yield* _await(
      api.formulationApprovals.create(projectId, apiData)
    );
    return this.saveListItem(result);
  });

  ofProject(projectId: identifier) {
    return this.listItems.get(projectId);
  }

  @modelAction
  reset() {
    this.listItems.clear();
  }
}

export default FormulationApprovalStore;
